import { Text } from "@react-pdf/renderer";
import { useMemo } from "react";

const PdfPrimaryTitle = ({ children, fontSize = 24, bold = true, style }) => {
  const styles = useMemo(() => {
    return {
      fontSize: fontSize,
      // marginBottom: 15,
      fontWeight: "bold",

      //

      marginBottom: 5,

      color: "#2962ff",
      ...style,
    };
  }, [style, fontSize]);

  return <Text style={styles}>{children}</Text>;
};

export default PdfPrimaryTitle;
